import { render, staticRenderFns } from "./CustomUpload.vue?vue&type=template&id=37c2fefa&scoped=true"
import script from "./CustomUpload.vue?vue&type=script&lang=js"
export * from "./CustomUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomUpload.vue?vue&type=style&index=0&id=37c2fefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c2fefa",
  null
  
)

export default component.exports